import { Deserializable } from '../../deserializable';
import { MortgageOfferDocumentDto } from './mortgage-offer-document-dto.model';

export class OfferDocumentsDto implements Deserializable {
  public OfferIdHash: string;
  public Documents: Array<MortgageOfferDocumentDto>;

  public deserialize(input: any): this {
    Object.assign(this, input);
    if (input.Documents) {
      this.Documents = input.Documents.map((mortgageOfferDocumentDto: MortgageOfferDocumentDto) =>
        new MortgageOfferDocumentDto().deserialize(mortgageOfferDocumentDto)
      );
    }

    return this;
  }
}
